import { render, staticRenderFns } from "./GridItems.vue?vue&type=template&id=71aa21e2"
import script from "./GridItems.vue?vue&type=script&lang=ts"
export * from "./GridItems.vue?vue&type=script&lang=ts"
import style0 from "./GridItems.vue?vue&type=style&index=0&id=71aa21e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports